<template>
  <div>
    <b-badge @click.prevent="showOpenReviewsModal" variant="warning" v-if="tableItems.length > 0" href="#">
      <font-awesome-icon icon="magnifying-glass" class="icon mr-1"/>
      <span v-if="tableItems.length === 1">1 Open Review</span>
      <span v-else>{{ tableItems.length }} Open Reviews</span>
    </b-badge>
    <b-modal :id="identifier" :ref="identifier" title="Open Machine File Reviews" hide-footer size="lg">
      <b-table :fields="fields" :items="tableItems" small striped class="mb-0">
        <template #cell(machineSerial)="data">
          <router-link :to="{ name: 'machine-file-review', params: { serial: data.value, uuid: data.item.uuid } }">{{ data.value }}</router-link>
        </template>
        <template #cell(timestamp)="data">
          {{ formattedTimestamp(data.value) }}
        </template>
        <template #cell(author)="data">
          {{ data.value || 'Unknown' }}
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>

import { machineFilesApi } from '@/backend'
import { DateTime } from 'luxon'

export default {
  name: 'openReviewsNotification',
  props: {
    machineSerial: {
      type: String,
      default: null
    },
    identifier: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      fields: [
        { key: 'machineSerial', label: 'Machine SN', sortable: true },
        { key: 'machineType', label: 'Machine Type', sortable: true },
        { key: 'customerName', label: 'Customer', sortable: true },
        { key: 'timestamp', label: 'Date', sortable: true },
        { key: 'author', label: 'Author', sortable: true }
      ],
      tableItems: []
    }
  },
  mounted () {
    this.fetchOpenReviews()
  },
  methods: {
    fetchOpenReviews () {
      const currentSerial = this.machineSerial
      if (currentSerial) {
        machineFilesApi.getSpecificMachineInformationForOpenReviewsNotification(currentSerial, (error, data) => {
          if (this.machineSerial !== currentSerial) {
            return
          }
          if (error) {
            console.error('Failed fetching open reviews because: ' + error)
            this.tableItems = []
            return
          }
          this.tableItems = data || []
        })
      } else {
        machineFilesApi.getAllMachinesInformationForOpenReviewsNotification((error, data) => {
          if (this.machineSerial) {
            return
          }
          if (error) {
            console.error('Failed fetching open reviews because: ' + error)
            this.tableItems = []
            return
          }
          this.tableItems = data || []
        })
      }
    },
    showOpenReviewsModal () {
      if (this.$refs[this.identifier]) {
        this.$refs[this.identifier].show()
      }
    },
    formattedTimestamp (timestamp) {
      return DateTime.fromJSDate(timestamp).toFormat('yyyy-MM-dd HH:mm')
    }
  },
  watch: {
    machineSerial (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchOpenReviews()
      }
    },
    $route () {
      if (this.$refs[this.identifier]) {
        this.$refs[this.identifier].hide()
      }

      // On route change fetch open reviews again, to prevent stale data.
      // If machineSerial is set, only fetch if machineSerial already matches the route param or route has no serial param,
      // avoiding fetching with a stale serial during route transitions.
      const routeSerial = this.$route.params.serial
      if (!this.machineSerial || !routeSerial || this.machineSerial.trim().toUpperCase() === routeSerial.trim().toUpperCase()) {
        this.fetchOpenReviews()
      }
    }
  }
}
</script>
